import React, { useState } from 'react';
import { PersonalInfo } from './sections/PersonalInfo';
import { AccountSettings } from './sections/AccountSettings';
import { PrivacySettings } from './sections/PrivacySettings';
import { LinkedAccounts } from './sections/LinkedAccounts';
import { NewsletterSettings } from './sections/NewsletterSettings';
import { AccountDeletion } from './sections/AccountDeletion';

const initialProfile = {
  name: 'Max Mustermann',
  email: 'max.mustermann@example.com',
  avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=200&h=200&auto=format&fit=crop',
  role: 'Administrator',
  timezone: 'Europe/Zurich',
  notifications: {
    email: true,
    push: true,
    updates: false
  }
};

export function ProfilePage() {
  const [profile, setProfile] = useState(initialProfile);
  const [settings, setSettings] = useState({
    twoFactor: true,
    language: 'de',
    timezone: 'Europe/Zurich',
    notifications: {
      email: true,
      push: true,
      marketing: false
    },
    newsletters: {
      product: true,
      marketing: false,
      blog: true
    },
    frequency: 'weekly',
    visibility: 'public',
    blockedUsers: []
  });

  return (
    <main className="flex-1 min-w-0 overflow-auto">
      <div className="max-w-[1440px] mx-auto animate-fade-in">
        <div className="flex flex-wrap justify-between gap-3 p-4">
          <h1 className="text-gray-900 dark:text-white text-2xl md:text-3xl font-bold">Profil</h1>
        </div>

        <div className="p-4 space-y-4">
          <PersonalInfo 
            profile={profile} 
            onUpdate={(updatedProfile) => setProfile(updatedProfile)} 
          />
          
          <AccountSettings 
            settings={settings} 
            onUpdate={(updatedSettings) => setSettings(updatedSettings)} 
          />
          
          <PrivacySettings 
            settings={settings} 
            onUpdate={(updatedSettings) => setSettings(updatedSettings)} 
          />
          
          <LinkedAccounts />
          
          <NewsletterSettings 
            settings={settings} 
            onUpdate={(updatedSettings) => setSettings(updatedSettings)} 
          />
          
          <AccountDeletion />
        </div>
      </div>
    </main>
  );
}